<i18n>
{
  "en": {
    "research": "Research",
    "design": "Design",
    "development": "Development",
    "production": "Production",
    "sustainability": "Sustainability",
    "about": "About us",
    "contacts": "Contacts"
  },
  "it": {
    "research": "Ricerca",
    "design": "Progettazione",
    "development": "Realizzazione",
    "production": "Produzione",
    "sustainability": "Sostenibilità",
    "about": "Chi siamo",
    "contacts": "Contatti"
  },

  "fr": {
    "research": "Recherche",
    "design": "Concevoir",
    "development": "Réalisation",
    "production": "Prodution",
    "sustainability": "Durabilité",
    "about": "Qui nous sommes",
    "contacts": "Contacts"
  }
}
</i18n>
<template>
  <div>
    <div class="menu container mx-auto">
      <div class="row">
        <div class="col-sm-4">
          <router-link :to="{ name: $i18n.locale + '.home'}"><img class="max-width-100" src="@/assets/img/logo.svg"></router-link>
        </div>
        <div class="col-sm-8">
          <div class="d-flex top-menu">
            <ul class="menu-items">
              <li>
                <router-link :to="{ name: $i18n.locale + '.about'}">
                  {{ $t('about') }}
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: $i18n.locale + '.contacts'}">
                  {{ $t('contacts') }}
                </router-link>
              </li>  
            </ul>
            <div class="langswitcher">
              <Langswitcher />
            </div>
          </div>

          <div class="desktop-menu">
              <ul class="menu-items">
                <li>
                  <router-link :to="{ name: $i18n.locale + '.research'}">
                    {{ $t('research') }}
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: $i18n.locale + '.design'}">
                    {{ $t('design') }}
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: $i18n.locale + '.development'}">
                    {{ $t('development') }}
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: $i18n.locale + '.production'}">
                    {{ $t('production') }}
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: $i18n.locale + '.sustainability'}">
                    {{ $t('sustainability') }}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
    </div>
    <div class="hamburger" v-bind:class="{ open: showMobile }" v-on:click="toggleShowMobile">
      <div class="line"></div>
    </div>
    <div class="mobile-menu" v-bind:class="{ open: showMobile }" v-show="showMobile" v-on:click="toggleShowMobile">
      <ul class="menu-items"></ul>
    </div>
  </div>
</template>

<script>
import Langswitcher from '@/components/Langswitcher.vue';

import { TweenMax } from "gsap";

export default {
  name: "Menu",
  components: {
    Langswitcher
  },
  props: {
    bus: {}
  },
  data() {
    return {
      showMobile: false
    };
  },
  mounted() {
    let container = this.$el.querySelector(".mobile-menu > .menu-items");
    for (let item of [...this.$el.querySelectorAll(
      ".desktop-menu > .menu-items li, .top-menu > .menu-items li"
    ), ...this.$el.querySelectorAll('.langswitcher')]) {
      let clone = item.cloneNode(true);
      container.appendChild(clone);
    }
  },
  methods: {
    toggleShowMobile(e) {
      console.log('clicked')
      this.showMobile = !this.showMobile;
    }
  }
};
</script>

<style lang="scss" scoped>
.langswitcher {
  z-index: 22;
  margin-top: 5px;
  margin-left: 20px;
  @include media-breakpoint-up(xl) {
    left: calc(100% - 60px);
  }

  /deep/ select {
    background: transparent;
    color: white;
    border: none;
    outline: none;
    appearance: none;
    cursor: pointer;
    text-align: left;
  }
}
.hamburger {
  position: absolute;
  right: 40px;
  top: 50px;
  z-index: 1022;
  
  display: block;
  height: 20px;
  width: 30px;
  cursor: pointer;
  overflow: hidden;
  .line {
    background: white;
    position: relative;
    top: 8.5px;
    width: 100%;
    height: 2px;
    transition: transform 0.2s ease-in;
  }
  &:after,
  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    background: white;
    transition: transform 0.2s ease-in 0.1s;
    transform-origin: 0 0;
  }
  &:after {
    top: 18px;
  }
  &.open {
    .line,
    &:before,
    &:after {
      background: white;
    }
    &:before {
      transform: rotate(37deg);
    }
    &:after {
      transform: rotate(-37deg);
    }
    .line {
      transform: translateX(100%);
    }
  }
}

.menu {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  font-family: $headings-font-family;
}

.mobile-menu {
  position: fixed;
  z-index: 1021;
  width: 100%;
  max-width: 500px;
  right: 0;
  top: 0;
  height: 100%;
  background: black;
  color: white;
  overflow-y: scroll;
  a {
    color: white;
  }
  .langswitcher {
    margin-top: 40px;
  }
  .open {
    background: black;
  }
  .menu-items {
    margin-top: 100px;
    margin-left: 5vw;
    li {
      list-style: none;
      margin-bottom: 5px;
      font-family: $headings-font-family;
      font-size: 40px;
    }
    > li > a {
      cursor: pointer;
      position: relative;
      &:after {
        display: inline-block;
        position: absolute;
        left: 100%;
        top: -0.45em;
        content: '.';
        color: $red;
        margin-left: 2px;
        font-size: 1.5em;
      }
    }
  }
}
        

.hamburger,
.mobile-menu {
  display: block;
  @include media-breakpoint-up(lg) {
    display: none;
  }
}

.top-menu {
  @include media-breakpoint-down(md) {
    display: none !important;
  }
  margin-top: 20px;
  justify-content: flex-end;
  text-align: right;
  font-size: 16px;
  display: flex;
  color: white;
  a {
    color: white;
  }
  ul {
    display: flex;
    margin: 0;
    padding: 0;
  }
  li {
    list-style: none;
    margin: 5px 10px;
  }
}
.desktop-menu {
  @include media-breakpoint-down(md) {
    display: none;
  }
  font-size: 20px;
  display: flex;
  color: white;
  ul {
    display: flex;
    margin: 0;
    padding: 0;
    margin-left: auto;
  }
  li {
    list-style: none;
    margin: 10px 15px;
  }
  a {
    color: white;
  }
}
</style>
